<template lang="pug">
  div(:class="isBulkEdit ? 'col-xs-5 col-xs-offset-1' : ''")
    p.lead
      i.fa.fa-fw.fa-building-o
      |
      |
      span 事業所{{officeNo}}

    div(v-for="field in fields" :key="field")
      card-field(v-model="value[field]" :maxlength="maxlengths[field]" :is-bulk-edit="isBulkEdit")

    .help-block(v-if="isBulkEdit && officeNo === '1'")
      p.bcard-required ※ (*)は必須項目です。
</template>

<script>
import CardField from '@/components/molecules/CardField'

export default {
  name: 'CardFormOffice',
  components: { CardField },
  props: {
    officeNo: { type: String, required: true },
    maxlengths: { type: Object, required: true },
    /**
     * @type Object value
     * @key フィールド名
     *    @param {String} label
     *    @param {String} field
     *    @param {String} value
     *    @param {Boolean} checked
     */
    value: { type: Object, required: true },
    isBulkEdit: { type: Boolean, required: false, default: false }
  },
  data () {
    return { fields: [] }
  },
  created () {
    this.fields = Object.keys(this.value)
  }
}
</script>

<style lang="scss" scoped>
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';
  // パンくず＞会社情報の一括更新（更新確認モード時）
  .breadcrumb-edit {
    cursor: pointer;
  }

  // 更新対象項目＞チェックボックス
  .form-group {
    .checkbox-rich {
      position: absolute;
      margin-top: 0;
      z-index: 1;
    }

    &.col-xs-12 {
      .checkbox-rich {
        margin-left: -8.33333%;
      }
    }

    &.col-sm-6 {
      .checkbox-rich {
        margin-left: -16.66666%;

        @media (max-width: $screen-xs-max) {
          margin-left: -8.33333%;
        }
      }
    }
  }

  .help-block {
    margin-left: -8.33333%;
  }
</style>



// WEBPACK FOOTER //
// src/components/organisms/forms/CardFormOffice.vue